import { getSessionStorageItem, SESSION_STORAGE_ACCOUNT_KEY } from '../../sessionStorage';

export const CustomerSupportPhone = () => {

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  var phone = "(844) 201-6080";

  if (accountObj && accountObj.account && accountObj.account.phone) {
    phone = accountObj.account.phone;
  }

  return phone;
}

export const CustomerSupportEmail = () => {

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  var email = "sales@covrtech.com";

  if (accountObj && accountObj.account && accountObj.account.customerSupportEmail) {
    email = accountObj.account.customerSupportEmail;
  }

  return email;
}

export const BrokerageOperationsPhone = () => {

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  var phone = "(833) 296-9697";

  if (accountObj && accountObj.account && accountObj.account.brokerageOperationsPhone) {
    phone = accountObj.account.brokerageOperationsPhone;
  }

  return phone;
}

export const BrokerageOperationsEmail = () => {

  const accountObj = getSessionStorageItem(SESSION_STORAGE_ACCOUNT_KEY);

  var email = "morganstanley@covrtech.com";

  if (accountObj && accountObj.account && accountObj.account.brokerageOperationsEmail) {
    email = accountObj.account.brokerageOperationsEmail;
  }

  return email;
}



// WEBPACK FOOTER //
// ./src/components/Account/ContactUsPhoneEmail.js